import axios from "axios";

const LeaveTypeService = {
    async getAll(){
        try{
            const response = await axios.get("/LeaveType/GetLeaveType");
            console.log("[LeaveType]getAll response:", response.data);
            return response.data;
        }catch(error){
            console.error("[LeaveType]Error Fetching leave types:", error);
            throw error;
        }
    },

    async getByUser(serviceNo){
        try{
            const url = `/EmpLeaveAllocation/GetEmpLeaveAllocation?p_empServiceNo=${encodeURIComponent(serviceNo)}`;
            const response = await axios.get(url);
            console.log("[LeaveType] getByUser response:", response.data);
            return response.data;
        } catch (error) {
            console.error("[LeaveType] Error fetching leave types by user:", error);
            throw error;
        }
    },
};

export default LeaveTypeService;